/**
 * Map axios/API errors to user-facing i18n messages.
 */
export function getApiErrorMessage(error, t) {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (status === 404) {
    const code = typeof data === 'string' ? data : data?.errorCode ?? data?.code;
    if (code === 'USER_NOT_FOUND' || String(code || '').includes('USER_NOT_FOUND')) {
      return t('users.errorNotFound');
    }
    return t('users.errorNotFound');
  }

  if (typeof data === 'string' && data.trim()) return data;
  if (data?.message) return data.message;
  if (error?.message && !/^Request failed with status code \d+$/i.test(error.message)) {
    return error.message;
  }
  return t('users.errorLoad');
}
